import React from 'react';
import StaticDatePickerUI from '../Interface/StaticDatePickerUI';
import dayjs from 'dayjs';

const RecruitmentCalendarFilter = ({ dates }) => {
  const { date, setDate } = dates;
  return (
    <div>
      <div className="w-full">
        <StaticDatePickerUI
          sx={{
            '& .MuiDatePickerToolbar-root': {
              display: 'none',
            },
            '& .MuiDialogActions-root': {
              display: 'none',
            },
            ' & .MuiDateCalendar-root': {
              background: '#f3f4f6',
            },
          }}
          value={dayjs(date)}
          onChange={(newDate) => {
            setDate((prevState) => ({
              ...prevState,
              startDate: newDate ? newDate.startOf('day') : null,
              endDate: newDate ? newDate.endOf('day') : null,
            }));
          }}
        />
      </div>
    </div>
  );
};

export default RecruitmentCalendarFilter;
